import withAemIntegration from "../../../withAemIntegration";
import loadable from "../../../utils/loadable";
const Component = loadable(() =>
  import(
    "@lexus.com/ui/dist/_nextgen/applications/MyLexus/components/VehicleManuals/index.impl"
  )
);

const EditConfig = {
  emptyLabel: "My Lexus - Manuals and Guides",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const Render = (props) => {
  return <Component {...props} />;
};

export default withAemIntegration(
  "lexus/components/content/my-lexus/manuals-and-guides"
)(Render, EditConfig);
